export const parkingReducer = (state: any, action: any) => {
  switch (action.type) {
    case 'ADD':
      return [
        ...state,
        {
          space: '',
          type: '',
        },
      ];
    case 'UPDATE':
      return state.map((state: any, index: number) => {
        if (index === action.payload.index) {
          return {
            ...state,
            [action.payload.field]: action.payload.value,
          };
        } else return state;
      });
    case 'UPDATEALL':
      return action.payload;
    case 'DELETE':
      return state.filter((state: any, index: number) => index !== action.payload.index);
    case 'DELETEALL':
      return [];
    default:
      throw new Error();
  }
};

export const washroomReducer = (state: any, action: any) => {
  switch (action.type) {
    case 'ADD':
      return [
        ...state,
        {
          count: '',
          pieces: '',
          level: '',
        },
      ];
    case 'UPDATE':
      return state.map((state: any, index: number) => {
        if (index === action.payload.index) {
          return {
            ...state,
            [action.payload.field]: action.payload.value,
          };
        } else return state;
      });
    case 'UPDATEALL':
      return action.payload;
    case 'DELETE':
      return state.filter((state: any, index: number) => index !== action.payload.index);
    case 'DELETEALL':
      return [];
    default:
      throw new Error();
  }
};

export const roomReducer = (state: any, action: any) => {
  switch (action.type) {
    case 'ADD':
      return [
        ...state,
        {
          level: '',
          name: '',
          length: '',
          width: '',
          height: '',
          description1: '',
          description2: '',
          description3: ''
        },
      ];
    case 'UPDATE':
      return state.map((state: any, index: number) => {
        if (index === action.payload.index) {
          return {
            ...state,
            [action.payload.field]: action.payload.value,
          };
        } else return state;
      });
    case 'UPDATEALL':
      return action.payload;
    case 'DELETE':
      return state.filter((state: any, index: number) => index !== action.payload.index);
    case 'DELETEALL':
      return [];
    default:
      throw new Error();
  }
};
